<template>
  <DynamicLink v-if="buttons?.length" :label="buttons[0].label" :link="buttons[0].link" class="button"/>
</template>

<script lang="ts">
import type {PropType} from 'vue'
import {DynamicLink} from '@/components/small'

export default {
  name: 'OptionalButtons',
  components: {DynamicLink},
  props: {
    buttons: {
      type: Array as PropType<Link[]>,
      default: null
    }
  }
}
</script>